<template>
  <div ref="scrollTarget"></div>
  <div class="container-fluid" style="height: 100%;">
    <div class="row">
      <main class="col-md-12" style=" background-color: #F7F7F8;">
        <div class="row justify-content-center" style="margin-top: 20px; margin-bottom: 100px;">
          <div class="col-12 text-center">
            <template v-if="shipments.length">
              <div class="filters mb-4">
                <div class="row g-2 align-items-center">
                  <!-- Order Date Filter -->
                  <div class="col-md-2 col-sm-12">
                    <label for="orderDateRange" class="form-label fw-bold">{{ translate('order_date') }}</label>
                    <div class="input-group input-group-sm">
                      <input type="date" v-model="filters.startDate" class="form-control" placeholder="Start Date"
                        id="startDate" />
                      <span class="input-group-text">to</span>
                      <input type="date" v-model="filters.endDate" class="form-control" placeholder="End Date"
                        id="endDate" />
                      <button v-if="filters.startDate || filters.endDate" class="btn btn-outline-secondary"
                        @click="clearDateFilter">
                        <i class="bi bi-x-circle"></i>
                      </button>
                    </div>
                  </div>

                  <div class="col-md-2 col-sm-12">
                    <label for="servicePoint" class="form-label fw-bold">{{ translate('service_point') }}</label>
                    <div class="input-group" style="flex-wrap: nowrap;">
                      <Select2 v-model="filters.servicePoint" :options="filteredServicePoints"
                        :placeholder="translate('all_service_points')" class="form-control border-0"
                        :settings="{ width: '100%', allowClear: true }"
                        style="flex: 1; border-top-right-radius: 0; border-bottom-right-radius: 0;" />
                    </div>
                  </div>

                  <!-- Ship From Filter -->
                  <div class="col-md-2 col-sm-12">
                    <label for="shipFrom" class="form-label fw-bold">{{ translate('ship_from') }}</label>
                    <div class="input-group" style="flex-wrap: nowrap;">
                      <Select2 v-model="filters.shipFrom" :options="filteredShipFrom" class="form-control border-0"
                        :settings="{ width: '100%', allowClear: true }"
                        style="flex: 1; border-top-right-radius: 0; border-bottom-right-radius: 0;" />
                    </div>
                  </div>

                  <!-- Ship To Filter -->
                  <div class="col-md-2 col-sm-12">
                    <label for="shipTo" class="form-label fw-bold">{{ translate('ship_to') }}</label>
                    <div class="input-group" style="flex-wrap: nowrap;">
                      <Select2 v-model="filters.shipTo" :options="filteredShipTo" class="form-control border-0"
                        :settings="{ width: '100%', allowClear: true }"
                        style="flex: 1; border-top-right-radius: 0; border-bottom-right-radius: 0;" />
                    </div>
                  </div>

                  <!-- Package Filter -->
                  <div class="col-md-1 col-sm-12">
                    <label for="package_type" class="form-label fw-bold">Package</label>
                    <div class="input-group" style="flex-wrap: nowrap;">
                      <Select2 v-model="filters.package_type" :options="filteredPackage" class="form-control border-0"
                        :settings="{ width: '100%', allowClear: true }"
                        style="flex: 1; border-top-right-radius: 0; border-bottom-right-radius: 0;" />
                    </div>
                  </div>

                  <!-- Transporter Filter -->
                  <div class="col-md-1 col-sm-12">
                    <label for="transporter" class="form-label fw-bold">Transporter</label>
                    <div class="input-group" style="flex-wrap: nowrap;">
                      <Select2 v-model="filters.transporter" :options="filteredTransporters"
                        class="form-control border-0" :settings="{ width: '100%', allowClear: true }"
                        style="flex: 1; border-top-right-radius: 0; border-bottom-right-radius: 0;" />
                    </div>
                  </div>

                  <!-- Transporter Number Filter -->
                  <div class="col-md-2 col-sm-12">
                    <label for="transporterNumber" class="form-label fw-bold">Transporter T.Number</label>
                    <div class="input-group" style="flex-wrap: nowrap;">
                      <Select2 v-model="filters.transporterNumber" :options="filteredTransporterNumbers"
                        class="form-control border-0" :settings="{ width: '100%', allowClear: true }"
                        style="flex: 1; border-top-right-radius: 0; border-bottom-right-radius: 0;" />
                    </div>
                  </div>

                  <!-- Clear All Filters Button -->
                  <div class="col-12 mt-2">
                    <button class="btn btn-danger" @click="clearAllFilters">
                      <i style="font-weight: bold;"></i> Clear All Filters
                    </button>
                  </div>

                </div>
              </div>
              
              <span style="background-color: #f858d6; color: white; font-weight: bold; padding-left: 10px; padding-right: 10px; border-radius: 5px;">
                Shipments Number : {{ filteredShipments.length }}
              </span>
              <br>
              <br>

              <div class="table-responsive-lg">
                <table class="table table-hover table-striped table-bordered table-responsive">
                  <thead class="table-dark">
                    <tr>
                      <th
                        style="vertical-align: middle; text-align: center; color: white; background-color: #E5097F; border: 1px solid #fff; border-top-left-radius: 12px;">
                        ID</th>
                      <th
                        style="vertical-align: middle; text-align: center; color: white; background-color: #E5097F; border: 1px solid #fff">
                        {{ translate('tracking_number') }}</th>
                      <th
                        style="vertical-align: middle; text-align: center; color: white; background-color: #E5097F; border: 1px solid #fff">
                        Order date</th>
                      <th
                        style="vertical-align: middle; text-align: center; color: white; background-color: #E5097F; border: 1px solid #fff">
                        Service point</th>
                      <th
                        style="vertical-align: middle; text-align: center; color: white; background-color: #E5097F; border: 1px solid #fff">
                        {{ translate('sender') }}</th>
                      <th
                        style="vertical-align: middle; text-align: center; color: white; background-color: #E5097F; border: 1px solid #fff">
                        {{ translate('ship_from') }}</th>
                      <th
                        style="vertical-align: middle; text-align: center; color: white; background-color: #E5097F; border: 1px solid #fff">
                        {{ translate('ship_to') }}</th>
                      <th
                        style="vertical-align: middle; text-align: center; color: white; background-color: #E5097F; border: 1px solid #fff">
                        {{ translate('weight') }}</th>
                      <th
                        style="vertical-align: middle; text-align: center; color: white; background-color: #E5097F; border: 1px solid #fff">
                        Transporter</th>
                      <th
                        style="vertical-align: middle; text-align: center; color: white; background-color: #E5097F; border: 1px solid #fff">
                        Tracking number</th>
                      <th
                        style="vertical-align: middle; text-align: center; color: white; background-color: #E5097F; border: 1px solid #fff">
                        Pickup refrence</th>
                      <th
                        style="vertical-align: middle; text-align: center; color: white; background-color: #E5097F; border: 1px solid #fff">
                        Shipping date</th>
                      <th
                        style="vertical-align: middle; text-align: center; color: white; background-color: #E5097F; border: 1px solid #fff">
                        Delivery date</th>
                      <th
                        style="vertical-align: middle; text-align: center; color: white; background-color: #E5097F; border: 1px solid #fff; border-top-right-radius: 12px;">
                        {{ translate('details') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="shipment in filteredShipments" :key="shipment.shipment_id">
                      <td style="vertical-align: middle; text-align: center; "> {{ shipment.shipment_id }}</td>
                      <td
                        style="vertical-align: middle; text-align: center; cursor: pointer; text-decoration: underline; font-weight: 600; color: #E5097F;"
                        @click="goToShipmentPage(shipment.tracking_number)"> {{ shipment.tracking_number }}</td>

                      <td style="vertical-align: middle; text-align: center; "> {{ shipment.order_date }}</td>
                      <td style="vertical-align: middle; text-align: center; "> {{ shipment.servicepoint }}</td>
                      <td style="vertical-align: middle; text-align: center;"> {{ shipment.sender }}</td>
                      <td style="vertical-align: middle; text-align: center;"> {{ shipment.ship_from }}</td>
                      <td style="vertical-align: middle; text-align: center;"> {{ shipment.ship_to }}</td>
                      <td style="vertical-align: middle; text-align: center;"> {{ shipment.package_type }} ({{
                        shipment.weight }} kg)
                      </td>
                      <td style="vertical-align: middle; text-align: center;"> {{ shipment.transporter }}</td>
                      <td style="vertical-align: middle; text-align: center;"> {{ shipment.transporter_number }}</td>
                      <td style="vertical-align: middle; text-align: center;"> {{ shipment.pickup_refrence }}</td>
                      <td :style="getBackgroundStyleShippingDate(shipment)"
                        style="vertical-align: middle; text-align: center;">
                        {{ shipment.shipping_date }}
                      </td>
                      <td :style="getBackgroundStyleDeliveryDate(shipment)"
                        style="vertical-align: middle; text-align: center;">
                        {{ shipment.delivery_date }}
                      </td>
                      <td
                        style="vertical-align: middle; text-align: center; color: #E5097F; cursor: pointer; text-decoration: underline;">
                        <span @click="selectShipment(shipment)">{{ translate('see_details') }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </template>
            <template v-else>
              <div class="container"
                style="text-align: center; color: white; font-weight: bold; font-size: 1.5em; background-color: #F1A8D0; padding: 60px; border-radius: 20px;">
                {{ translate('no_orders') }}
              </div>
            </template>

            <div v-if="selectedShipment" class="modal">
              <div class="modal-content">
                <span style="text-align: right;" @click="closeModal" class="close">&times;</span>
                <div style="text-align: center;">
                  <p style="color: #E5097F;"><strong style="color: #E5097F;">{{ translate('tracking_number') }} :
                    </strong> {{ selectedShipment.tracking_number }}</p>
                </div>
                <div class="modal-body">
                  <div class="column">
                    <p><strong>Pickup address : </strong> {{ selectedShipment.pickup_address }}</p>
                    <p><strong>Delivery address : </strong> {{ selectedShipment.receiver_address }}</p>

                    <br>
                    <p><strong>Sender</strong></p>
                    <p><span style="font-weight: 600;">Full Name : </span>{{ selectedShipment.sender_name }}</p>
                    <p><span style="font-weight: 600;">Company Name : </span>{{ selectedShipment.sender_company_name }}
                    </p>
                    <p><span style="font-weight: 600;">Email : </span>{{ selectedShipment.sender_email }}</p>
                    <p><span style="font-weight: 600;">Phone : </span>{{ selectedShipment.sender_phone }}</p>
                    <p><span style="font-weight: 600;">Address : </span>{{ selectedShipment.sender_address }}</p>
                    <br>

                    <p><strong>Receiver</strong></p>
                    <p><span style="font-weight: 600;">Full Name : </span>{{ selectedShipment.receiver_name }}</p>
                    <p><span style="font-weight: 600;">Company Name : </span>{{ selectedShipment.receiver_company_name
                      }}</p>
                    <p><span style="font-weight: 600;">Email : </span>{{ selectedShipment.receiver_email }}</p>
                    <p><span style="font-weight: 600;">Phone : </span>{{ selectedShipment.receiver_phone }}</p>
                    <p><span style="font-weight: 600;">Address : </span>{{ selectedShipment.receiver_address }}</p>
                  </div>
                  <div class="column">
                    <p><strong>{{ translate('package_type') }} : </strong> {{ selectedShipment.package_type }}</p>
                    <p><strong>{{ translate('weight') }} : </strong> {{ selectedShipment.weight }}</p>
                    <br>
                    <p><strong>{{ translate('shipping_date') }} : </strong> {{ selectedShipment.shipping_date }}</p>
                    <p><strong>{{ translate('delivery_date') }} : </strong> {{ selectedShipment.delivery_date }}</p>
                    <p><strong>Transporter : </strong> {{ selectedShipment.transporter }}</p>
                    <p><strong>Tracking Number : </strong> {{ selectedShipment.transporter_number }}</p>
                    <p><strong>Pickup refrence : </strong> {{ selectedShipment.pickup_refrence }}</p>
                    <p><strong>Purchase price : : </strong> <span class="badge bg-success rounded-pill"
                        style="font-size: 0.8em;">{{
                          selectedShipment.purchase_price }} &euro;</span></p>
                    <p><strong>Sale price : </strong> <span class="badge bg-success rounded-pill"
                        style="font-size: 0.8em;">{{
                          selectedShipment.price }} &euro;</span></p>
                    <br>
                    <p><strong>Discount : </strong> {{ selectedShipment.discount }}%</p>
                    <p><strong>Assurance : </strong> {{ selectedShipment.insurance_option }}</p>
                    <p><strong>Printer request : </strong> {{ selectedShipment.printer }}</p>

                    <br>
                    <p><strong>Proforma invoice : </strong>
                      <i v-if="selectedShipment.proformainvoice" class="fa fa-print"
                        @click="printProformaInvoice(selectedShipment.shipment_id)"
                        style="cursor: pointer; color: #E5097F; font-size: x-large;"></i>
                      <i v-else class="fa fa-print" aria-hidden="true"
                        style="color: #aaa; font-size: x-large; cursor: not-allowed;"></i>
                    </p>
                    <p><strong>Sale ticket : </strong>
                      <i v-if="selectedShipment.saleticket === 'True'" class="fa fa-print"
                        @click="printsaleticket(selectedShipment.saleticket_id)"
                        style="cursor: pointer; color: #E5097F; font-size: x-large;"></i>
                      <i v-else class="fa fa-print" aria-hidden="true"
                        style="color: #aaa; font-size: x-large; cursor: not-allowed;"></i>
                    </p>
                    <p><strong>Shipping label : </strong>
                      <i v-if="selectedShipment.shippinglabel === 'True'" class="fa fa-print"
                        @click="printshippinglabel(selectedShipment.shipment_id)"
                        style="cursor: pointer; color: #E5097F; font-size: x-large;"></i>
                      <i v-else class="fa fa-print" aria-hidden="true"
                        style="color: #aaa; font-size: x-large; cursor: not-allowed;"></i>
                    </p>
                  </div>
                </div>
                <div>
                  <button class="btn btn-success" @click="showNotes">Suivi</button>
                  <button style="margin-left: 20px; color: white;" class="btn btn-warning" @click="DeliveredShipmentAlert(selectedShipment.shipment_id)">Mark As Delivered</button>
                  <template v-if="!selectedShipment.transporter_number">
                  <button style="margin-left: 20px; color: white;" class="btn btn-info" @click="CreateAWB(selectedShipment.shipment_id)">Create AWB</button>
                </template>
                <template v-if="selectedShipment.pickup_refrence == 'None None'">
                  <button style="margin-left: 20px; color: white;" class="btn btn-primary" @click="CreatePICKUP(selectedShipment.shipment_id)">Create PICKUP</button>
                </template>
                  <button style="margin-left: 20px; background-color:#fd7e14; color:white;" class="btn" @click="CancelShipmentAlert(selectedShipment.shipment_id)">Annuler</button>
                  <button style="margin-left: 20px;" class="btn btn-danger" @click="DeleteShipmentAlert(selectedShipment.shipment_id)">Delete</button>
                </div>
              </div>
            </div>

            <div v-if="show_notes" class="modal">
              <div class="modal-content" style="width: 70%;">
                <span style="text-align: right;" @click="closeModal2" class="close">&times;</span>
                <div style="text-align: center;">
                  <p style="color: #E5097F;"><strong style="color: #E5097F;">{{ translate('tracking_number') }} :
                    </strong> {{ selectedShipment.tracking_number }}</p>
                </div>

                <div>
                  <div class="row text-center" style="margin-top: 20px;">
                    <div class="col">
                      <input type="text" class="form-control" placeholder="Status" v-model="status_note">
                    </div>
                    <div class="col">
                      <input type="text" class="form-control" placeholder="Description" v-model="description_note">
                    </div>
                    <div class="col" style="text-align: left;">
                      <button class="btn btn-success" @click="addNote(selectedShipment.shipment_id)">Add</button>
                    </div>
                  </div>

                  <div class="row" style="margin-top: 20px;" v-for="(note, index) in notes" :key="index">
                    <div class="col text-center">
                      <label>Date</label>
                      <input type="text" class="form-control" v-model="note.date" readonly
                        style="background-color: lightgrey;">
                    </div>
                    <div class="col text-center">
                      <label>Status</label>
                      <input type="text" class="form-control" v-model="note.status" readonly
                        style="background-color: lightgrey;">
                    </div>
                    <div class="col text-center">
                      <label>Description</label>
                      <textarea cols="3" type="text" class="form-control" v-model="note.description" readonly
                        style="background-color: lightgrey;"></textarea>
                    </div>
                    <div class="col text-center">
                      <label>Created by</label>
                      <input type="text" class="form-control" v-model="note.created_by" readonly
                        style="background-color: lightgrey;">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>


<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import Select2 from 'vue3-select2-component';
import en from '../en.js';
import fr from '../fr.js';
import nl from '../nl.js';


export default {
  name: 'Dashboard',
  mixins: [en, fr, nl],
  components: {
    Select2
  },
  data() {
    return {
      user: {},
      today_shipments: "",
      progress_shipments: "",
      delivered_shipments: "",
      all_shipments: "",
      today_date: "",
      shipments_statistics: [],
      commissions_statistics: [],
      commission_amount: "",
      shipments: [],
      notes: [],
      company: {},
      selectedShipment: null,
      status_note: "",
      description_note: "",
      show_notes: false,
      filters: {
        servicePoint: "",
        shipFrom: "",
        shipTo: "",
        transporter: "",
        transporterNumber: "",
        startDate: "",
        endDate: "",
      },
    }
  },
  computed: { 
    lang() {
      return this.$store.state.lang
    },
    filteredShipments() {
      return this.shipments.filter((shipment) => {
        const orderDate = new Date(shipment.order_date.split(" ")[0].split("-").reverse().join("-"));

        const startDate = this.filters.startDate ? new Date(this.filters.startDate) : null;
        const endDate = this.filters.endDate ? new Date(this.filters.endDate) : null;

        const isWithinDateRange =
          (!startDate || orderDate >= startDate) &&
          (!endDate || orderDate <= endDate);

        return (
          isWithinDateRange &&
          (!this.filters.servicePoint || shipment.servicepoint === this.filters.servicePoint) &&
          (!this.filters.shipFrom || shipment.ship_from === this.filters.shipFrom) &&
          (!this.filters.shipTo || shipment.ship_to === this.filters.shipTo) &&
          (!this.filters.package_type || shipment.package_type === this.filters.package_type) &&
          (!this.filters.transporter || shipment.transporter === this.filters.transporter) &&
          (!this.filters.transporterNumber || shipment.transporter_number === this.filters.transporterNumber)
        );
      });
    },
    filteredServicePoints() {
      return [
        ...new Set(
          this.filteredShipments.map((shipment) =>
            shipment.servicepoint === null ? 'Unknown' : shipment.servicepoint
          )
        ),
      ];
    },
    filteredShipFrom() {
      return [
        ...new Set(
          this.filteredShipments.map((shipment) =>
            shipment.ship_from === null ? 'Unknown' : shipment.ship_from
          )
        ),
      ];
    },
    filteredShipTo() {
      return [
        ...new Set(
          this.filteredShipments.map((shipment) =>
            shipment.ship_to === null ? 'Unknown' : shipment.ship_to
          )
        ),
      ];
    },
    filteredPackage() {
      return [
        ...new Set(
          this.filteredShipments.map((shipment) =>
            shipment.package_type === null ? 'Unknown' : shipment.package_type
          )
        ),
      ];
    },
    filteredTransporters() {
      return [
        ...new Set(
          this.filteredShipments.map((shipment) =>
            shipment.transporter === null ? 'Unknown' : shipment.transporter
          )
        ),
      ];
    },
    filteredTransporterNumbers() {
      return [
        ...new Set(
          this.filteredShipments.map((shipment) =>
            shipment.transporter_number === null ? 'Unknown' : shipment.transporter_number
          )
        ),
      ];
    },
  },
  async mounted() {
    document.title = 'Dashboard | Orders';
    const element = this.$refs.scrollTarget;
    element.scrollIntoView({ behavior: 'smooth' });
    window.scrollTo(0, 0);

    this.UpdateShipmentsStatus();
    this.$store.commit('setIsLoading', true)
    await this.fetchShipments()
    this.$store.commit('setIsLoading', false)

  },
  methods: {
    translate(prop) {
      const currentLang = this.lang || 'en';
      const dict = this[currentLang] || this.en || {};
      return dict[prop] || '';
    },
    async fetchShipments() {
      try {
        const response = await axios.post('/api/v1/admin/get-orders-progress/');
        this.shipments = response.data['shipments'];
      } catch (error) {
        console.error('Error fetching shipments:', error);
      }
    },
    async UpdateShipmentsStatus() {
      await axios.post('/api/v1/update-shipment-status/')
        .then(response => {
          console.log("Shipments are updated")
        })
        .catch(error => {
          console.log(JSON.stringify(error))
        })
    },
    getBackgroundStyleShippingDate(shipment) {
      const { shipping_date, pickup_shipment } = shipment;
      if (pickup_shipment) {
        return { backgroundColor: 'green', color: 'white' };
      }

      const [day, month, year] = shipping_date.split('-').map(Number);
      const shippingDateObj = new Date(year, month - 1, day);
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      if (shippingDateObj < today) {
        return { backgroundColor: 'red', color: 'white' };
      }

      return { backgroundColor: 'yellow', color: 'black' };
    },
    getBackgroundStyleDeliveryDate(shipment) {
      const { delivery_date, delivered_shipment } = shipment;

      const [day, month, year] = delivery_date.split('-').map(Number);
      const DeliverygDateObj = new Date(year, month - 1, day);
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      if (DeliverygDateObj < today) {
        return { backgroundColor: 'red', color: 'white' };
      }

      return { backgroundColor: 'yellow', color: 'black' };
    },
    async fetchNotes(shipment_id) {
      try {
        const response = await axios.post('/api/v1/admin/get-notes/' + shipment_id + "/");
        this.notes = response.data['notes'];
      } catch (error) {
        console.error('Error fetching shipments:', error);
      }
    },
    goToShipmentPage(shipmentId) {
      this.$router.push(`/track/${shipmentId}`);
    },
    editShipment(shipmentId) {
      this.$router.push(`/edit/shipment/${shipmentId}`);
    },
    CreateAWB(shipmentId){
      this.$router.push(`/create-awb/${shipmentId}`);
    },
    CreatePICKUP(shipmentId){
      this.$router.push(`/create-pickup/${shipmentId}`);
    },
    async getServicePoint(user_id) {
      await axios.post('/api/v1/getservicepoint/')
        .then(response => {
          this.company = response.data
        })
        .catch(error => {
          console.log(JSON.stringify(error))
        })
    },
    async addNote(shipment_id) {
      const formData = {
        status: this.status_note,
        description: this.description_note,
      }
      this.$store.commit('setIsLoading', true)
      await axios
        .post(`/api/v1/admin/add-note/${shipment_id}/`, formData)
        .then(response => {
          this.fetchNotes(this.selectedShipment.shipment_id)
        })
        .catch(error => {
          if (error.response) {
            this.errors.push(this.translate('login_error'))
          } else {
            this.errors.push('Something went wrong. Please try again')

            console.log(JSON.stringify(error))
          }
        })
      this.$store.commit('setIsLoading', false)
    },
    DeleteShipmentAlert(shipment_id) {
      Swal.fire({
        icon: 'question',
        title: 'Delete Shipment',
        text: 'Are you sure you want to delete this shipment ?',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        confirmButtonColor: '#4BB543',
        cancelButtonColor: '#ff0e0e',
      }).then((result) => {
        if (result.isConfirmed) {
          this.DeleteShipment(shipment_id)
        }
      });
    },
    DeliveredShipmentAlert(shipment_id) {
      Swal.fire({
        icon: 'question',
        title: 'Mark Shipment As Delivered',
        text: 'Are you sure you want to do this change ?',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        confirmButtonColor: '#4BB543',
        cancelButtonColor: '#ff0e0e',
      }).then((result) => {
        if (result.isConfirmed) {
          this.DeliveredShipment(shipment_id)
        }
      });
    },
    async DeleteShipment(shipment_id) {
      this.$store.commit('setIsLoading', true)
      await axios
        .post(`/api/v1/admin/delete-shipment/${shipment_id}/`)
        .then(response => {
          this.fetchShipments();
          this.closeModal();
        })
        .catch(error => {
          if (error.response) {
            this.errors.push(this.translate('login_error'))
          } else {
            this.errors.push('Something went wrong. Please try again')
            console.log(JSON.stringify(error))
          }
        })
      this.$store.commit('setIsLoading', false)
    },
    CancelShipmentAlert(shipment_id) {
      Swal.fire({
        icon: 'warning',
        title: 'Annuler la course',
        text: 'L\'ordre d\'annulation sera transmis au transporteur (FedEx/UPS), et la course sera marquee ANNULEE (reversible). Rien n\'est supprime. Merci d\'indiquer le motif :',
        input: 'text',
        inputPlaceholder: 'Motif de l\'annulation',
        showCancelButton: true,
        confirmButtonText: 'Confirmer l\'annulation',
        cancelButtonText: 'Retour',
        confirmButtonColor: '#fd7e14',
        cancelButtonColor: '#6c757d',
        inputValidator: (value) => {
          if (!value || !value.trim()) {
            return 'Le motif est obligatoire';
          }
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.CancelShipment(shipment_id, result.value)
        }
      });
    },
    async CancelShipment(shipment_id, reason, force = false) {
      this.$store.commit('setIsLoading', true)
      await axios
        .post(`/api/v1/admin/cancel-shipment/${shipment_id}/`, { reason: reason, force: force })
        .then(response => {
          this.fetchShipments();
          this.closeModal();
          const cm = (response.data && response.data.carrier_message) ? ('<br><br><b>Transporteur :</b> ' + response.data.carrier_message) : '';
          Swal.fire({ icon: 'success', title: 'Course annulee', html: 'La course a ete annulee et tracee dans l\'historique.' + cm, confirmButtonColor: '#4BB543' });
        })
        .catch(error => {
          if (error.response && error.response.status === 409 && error.response.data && error.response.data.carrier_failed) {
            const msg = error.response.data.carrier_message || '';
            Swal.fire({
              icon: 'warning',
              title: 'Le transporteur a refuse l\'annulation',
              html: '<b>' + msg + '</b><br><br>Veux-tu quand meme annuler la course dans le systeme ? (le colis ne sera PAS arrete chez le transporteur)',
              showCancelButton: true,
              confirmButtonText: 'Annuler quand meme dans le systeme',
              cancelButtonText: 'Non, laisser active',
              confirmButtonColor: '#dc3545',
              cancelButtonColor: '#6c757d',
            }).then((r) => {
              if (r.isConfirmed) {
                this.CancelShipment(shipment_id, reason, true);
              }
            });
          } else if (error.response && error.response.data && error.response.data.error) {
            Swal.fire({ icon: 'error', title: 'Erreur', text: error.response.data.error });
          } else {
            this.errors.push('Something went wrong. Please try again')
            console.log(JSON.stringify(error))
          }
        })
      this.$store.commit('setIsLoading', false)
    },
    async DeliveredShipment(shipment_id) {
      this.$store.commit('setIsLoading', true)
      await axios
        .post(`/api/v1/admin/delivered-shipment/${shipment_id}/`)
        .then(response => {
          this.fetchShipments();
          this.closeModal();
        })
        .catch(error => {
          if (error.response) {
            this.errors.push(this.translate('login_error'))
          } else {
            this.errors.push('Something went wrong. Please try again')
            console.log(JSON.stringify(error))
          }
        })
      this.$store.commit('setIsLoading', false)
    },
    showNotes() {
      this.show_notes = true;
      this.fetchNotes(this.selectedShipment.shipment_id)
    },
    async printshippinglabel(shipment_id) {
      const url = `https://api.eurekali-point.com/api/v1/shhippinglabel/print/${shipment_id}/`;
      window.open(url, '_blank');
    },
    async printsaleticket(saleticket_id) {
      const url = `https://api.eurekali-point.com/api/v1/saleticket/print/${saleticket_id}/`;
      window.open(url, '_blank');
    },
    async printProformaInvoice(shipment_id) {
      const url = `https://api.eurekali-point.com/api/v1/proformainvoice/print/${shipment_id}/`;
      window.open(url, '_blank');
    },
    selectShipment(shipment) {
      this.selectedShipment = shipment;
    },
    closeModal() {
      this.selectedShipment = null;
    },
    closeModal2() {
      this.show_notes = false;
      this.status_note = "";
      this.description_note = "";
    },
    clearFilter(filterKey) {
      this.filters[filterKey] = "";
    },
    clearDateFilter() {
      this.filters.startDate = "";
      this.filters.endDate = "";
    },
    clearAllFilters() {
      // Reset all filter values
      this.filters = {
        startDate: '',
        endDate: '',
        servicePoint: '',
        shipFrom: '',
        shipTo: '',
        transporter: '',
        transporterNumber: '',
      };
    },
    logout() {
      axios.defaults.headers.common["Authorization"] = ""
      sessionStorage.removeItem("token")
      this.$store.commit('removeToken')
      this.$store.commit('clearShipment')
      this.$router.push('/login')
    }
  }
}
</script>

<style>
.custom {
  border: none;
  cursor: pointer;
  font-size: 15px;
  padding-bottom: 10px;

}

.custom:hover {
  color: #E5097F;
  font-weight: bold;
}


.active-item {
  color: #E5097F;
  font-weight: bold;
}

.img-item {
  margin-right: 8px;
}

.red-header tr {
  background-color: red;
  color: white;
}

.btn-new-ship {
  color: #E5097F;
  font-weight: bold;
  background-color: #fff;
  border: 2px solid #E5097F;
  border-radius: 20px;
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 2px;
  padding-top: 2px;
}

.btn-new-ship:hover {
  background-color: #9b0656;
  color: white;
  border: 2px solid #9b0656;
}


.btn-more {
  color: #fff;
  font-weight: bold;
  background-color: #E5097F;
  border: 2px solid #E5097F;
  margin-left: 10px;
  border-radius: 20px;
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 5px;
  padding-top: 5px;
}

.btn-more:hover {
  background-color: #9b0656;
  border: 2px solid #9b0656;
}

.btn-request {
  background-color: #BCF2C0;
  margin-left: 12px;
  border-radius: 20px;
  border: 2px solid #37B980;
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 5px;
  padding-top: 5px;
  font-weight: bold;
}

.btn-request:hover {
  background-color: #37B980;
  color: white;
}


.box-shadow-custom {
  box-shadow: 1px 1px 1px #aaa, -1px -1px 1px #aaa;
}


.bg-progress {
  background-color: #D5CB41;
}

.bg-delivered {
  background-color: #41D54B;
}

.modal {
  display: block;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  color: black;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
}

.modal-body {
  display: flex;
  justify-content: space-between;
}

.column {
  width: 50%;
  text-align: left;
}

.modal-content {
  background-color: #FEEEF6;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
  margin-top: 150px;
}

.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

.pickup_class {
  background-color: #b0e56b;
  color: white;
}

.nopickup_class {
  background-color: #F44336;
  color: white;
}

.filters {
  background-color: #f8f9fa;
  /* Light gray background */
  padding: 0.8rem;
  /* Compact padding */
  border-radius: 6px;
  /* Slightly rounded corners */
  border: 1px solid #ddd;
  /* Subtle border */
}

.filters .form-label {
  font-size: 0.85rem;
  /* Smaller font size for labels */
  color: #495057;
  /* Neutral color */
}

.filters .form-control,
.filters .form-select {
  height: 30px;
  /* Compact height */
  font-size: 0.85rem;
  /* Adjust font size */
  padding: 4px 8px;
  /* Compact padding */
}

.filters .btn {
  height: 30px;
  /* Match input height */
  font-size: 0.75rem;
  /* Smaller button text */
  padding: 0 8px;
  /* Compact padding */
}

.filters .bi {
  font-size: 1rem;
  /* Standard icon size */
  color: #6c757d;
  /* Default icon color */
}

.filters .bi:hover {
  color: #dc3545;
  /* Red color on hover */
}
</style>